import { scrollTo } from '../../../application/typescript/utils/utils';

class BlockArchiveQuestions {
  constructor() {
    this._init();
  }

  _init() {
    const chips = document.querySelectorAll('.archive-questions__chip');

    chips.forEach(function (chip) {
      chip.addEventListener(
        'click',
        () => {
          let category = chip.getAttribute('data-category');
          const list = document.querySelector(
            '.archive-questions__list[data-category="' + category + '"]'
          );
          if (category && list) {
            scrollTo(list, 20);
          }
        },
        false
      );
    });
  }
}

export const blockArchiveQuestions = new BlockArchiveQuestions();
